import SearchRequestAdvice from './SearchRequestAdvice'

export default SearchRequestAdvice
